// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Activité#Activités',
    Activities_Text: '1#{0} activité#{0} activités',
    activities_without_dates: 'Activités sans dates',
    Activity: 'Activité',
    Activity_Billing: 'Facturable',
    Activity_Cost: 'Activité facturable',
    Activity_CostVariance: 'Écart de coût',
    Activity_HoursLeft: 'restant',
    Activity_InternalCost: 'Coût réel',
    Activity_Profit: 'Profit',
    Add_Task: 'Ajouter une tâche',
    AITaskGeneration_projectName: 'Nom',
    AITaskGeneration_retry: 'Réessayer',
    AITaskGeneration_title: 'Créer un plan de projet avec l\'IA',
    All_Saved_Views: 'Toutes les vues enregistrées',
    Apply_Text: 'Appliquer',
    apply_wbs_sorting: 'Appliquer le tri WBS',
    Archive_Success_Message: 'Le projet \"{0}\" a été archivé',
    archived_label: '(archivé)',
    Baseline_Text: 'Référence',
    batch_info_all_checked: 'Le parent et toutes les sous-activités sont cochés',
    batch_info_only_parent_checked: 'Seule l\'activité parent est cochée',
    batch_info_sub_tasks_checked: 'Des sous-activités sont cochées, mais le parent ne l\'est pas',
    batch_info_title: 'Icônes d\'opérations par lot :',
    Board_CreateTaskInProjectPlaceholder: 'Créer dans le projet',
    Board_ShowMore: 'Afficher plus',
    Browse_Views: 'Parcourir les vues',
    Budget_problem_project: 'Le coût réel dépasse le budget total',
    Budget_problem_task: 'Le coût de main-d\'œuvre réel dépasse le budget total',
    Budget_Text: 'Budget',
    Budget_warning_project: 'Le coût EAC dépasse le budget total',
    Budget_warning_task: 'Le coût de main-d\'œuvre EAC dépasse le budget total',
    By_Text: 'par',
    change_activity_type_to_label: 'Changer le type d\'activité en',
    ChooseTemplateDropdownLabel: 'Créer un projet basé sur un modèle existant',
    Counter: 'Compteur de projets/activités',
    CPI_Problem: 'Le CPI est en dessous du seuil',
    Create: 'Créer',
    create_snapshot: 'Instantanés du projet',
    CreateNewItem: 'Tapez ici pour créer un nouveau projet ou une nouvelle activité...',
    CreateProject_Tooltip: 'Créer un nouveau projet',
    CriticalPath_Text: 'Chemin critique',
    CustomField_No: 'Non',
    CustomField_Yes: 'Oui',
    DayPluralFormat: '1#Jour#Jours',
    Default_Text: 'Par défaut',
    Delete_Confirmation_Title: 'Supprimer ces objets ?',
    Delete_Entity_Confirmation_Archive_Description: '<b>Vous pouvez également archiver les données du projet et les restaurer si nécessaire.</b>',
    Delete_Project_Title: 'Supprimer le projet \"{0}\" (ID {1}) ?',
    Delete_Task_Title: 'Supprimer l\'activité \"{0}\" (ID {1}) ?',
    Delete_Text: 'Supprimer',
    DeleteEntityConfirmation: 'y compris tous les journaux de temps, messages et fichiers joints {0}. Cette action ne peut pas être annulée !',
    DeletePermanently: 'Supprimer définitivement',
    DeleteVerb: '1#sera définitivement supprimé#seront définitivement supprimés',
    DeleteVerbActivity: '1#sera définitivement supprimée#seront définitivement supprimées',
    Dependency_AddMore_Text: 'Ajouter plus de dépendances',
    Dependency_Cancel: 'Annuler',
    Dependency_Choose: 'Sélectionnez une activité ou saisissez un mot-clé... ',
    Dependency_days: 'jours',
    Dependency_DelayWarningExample: 'Exemple : -34, 42',
    Dependency_DelayWarningText: 'Entrez des nombres de -1000 à 1000',
    Dependency_DependencyCycle: 'Désolé, la dépendance ne peut pas être créée car l\'activité sélectionnée crée une boucle de dépendance.',
    Dependency_DependencyType_Text: 'Type de dépendance',
    Dependency_DependsOn_Text: 'Dépend de',
    Dependency_FinishToStart_Minus1: 'L\'activité commence la veille de la fin de {0}',
    Dependency_FinishToStart_Minus1_Pattern: 'L\'activité commence <b>la veille</b> de la fin de \"{0}\"',
    Dependency_FinishToStart_Minus2: 'L\'activité commence {1} avant la fin de {0}',
    Dependency_FinishToStart_Minus2_Pattern: 'L\'activité commence <b>{1} avant</b> la fin de \"{0}\"',
    Dependency_FinishToStart_Plus0: 'L\'activité commence le jour où {0} se termine',
    Dependency_FinishToStart_Plus0_Pattern: 'L\'activité commence <b>le jour</b> où \"{0}\" se termine',
    Dependency_FinishToStart_Plus1: 'L\'activité commence le lendemain de la fin de {0}',
    Dependency_FinishToStart_Plus1_Pattern: 'L\'activité commence <b>le lendemain</b> de la fin de \"{0}\"',
    Dependency_FinishToStart_Plus2: 'L\'activité commence {1} après la fin de {0}',
    Dependency_FinishToStart_Plus2_Pattern: 'L\'activité commence <b>{1} après</b> la fin de \"{0}\"',
    Dependency_FinishWhenStarted_Text: 'L\'activité se termine quand \"{0}\" commence',
    Dependency_FinishWhenStarted_Title: 'Début à fin',
    Dependency_Lag_Text: 'Décalage',
    Dependency_ParentChildRelationship: 'Désolé, la dépendance ne peut pas être créée car l\'une des activités est un parent et l\'autre est son enfant (sous-activité).',
    Dependency_Reason: 'Raison',
    Dependency_Remove_Text: 'Retirer',
    Dependency_RemoveSingleDependency_Text: 'Retirer la dépendance',
    Dependency_Save: 'Enregistrer',
    Dependency_SelectDependsOn_Text: 'Sélectionner Dépend de',
    Dependency_StartsWhenFinished_Text: 'L\'activité commence quand \"{0}\" est terminée',
    Dependency_StartsWhenFinished_Title: 'Fin à début',
    Dependency_StartsWhenStarted_Text: 'L\'activité commence quand \"{0}\" commence',
    Dependency_StartsWhenStarted_Title: 'Début à début',
    Dependency_StartToFinish_Minus1: 'L\'activité se termine la veille du début de {0}',
    Dependency_StartToFinish_Minus1_Pattern: 'L\'activité se termine <b>la veille</b> du début de \"{0}\"',
    Dependency_StartToFinish_Minus2: 'L\'activité se termine {1} avant le début de {0}',
    Dependency_StartToFinish_Minus2_Pattern: 'L\'activité se termine <b>{1} avant</b> le début de \"{0}\"',
    Dependency_StartToFinish_Plus0: 'L\'activité se termine le jour où {0} commence',
    Dependency_StartToFinish_Plus0_Pattern: 'L\'activité se termine <b>le jour</b> où \"{0}\" commence',
    Dependency_StartToFinish_Plus1: 'L\'activité se termine le jour après le début de {0}',
    Dependency_StartToFinish_Plus1_Pattern: 'L\'activité se termine <b>le jour après</b> le début de \"{0}\"',
    Dependency_StartToFinish_Plus2: 'L\'activité se termine {1} après le début de {0}',
    Dependency_StartToFinish_Plus2_Pattern: 'L\'activité se termine <b>{1} après</b> le début de \"{0}\"',
    Dependency_StartToStart_Minus1: 'L\'activité commence le jour avant le début de {0}',
    Dependency_StartToStart_Minus1_Pattern: 'L\'activité commence <b>le jour avant</b> le début de \"{0}\"',
    Dependency_StartToStart_Minus2: 'L\'activité commence {1} avant le début de {0}',
    Dependency_StartToStart_Minus2_Pattern: 'L\'activité commence <b>{1} avant</b> le début de \"{0}\"',
    Dependency_StartToStart_Plus0: 'L\'activité commence le jour où {0} commence',
    Dependency_StartToStart_Plus0_Pattern: 'L\'activité commence <b>le jour</b> où \"{0}\" commence',
    Dependency_StartToStart_Plus1: 'L\'activité commence le jour après le début de {0}',
    Dependency_StartToStart_Plus1_Pattern: 'L\'activité commence <b>le jour après</b> le début de \"{0}\"',
    Dependency_StartToStart_Plus2: 'L\'activité commence {1} après le début de {0}',
    Dependency_StartToStart_Plus2_Pattern: 'L\'activité commence <b>{1} après</b> le début de \"{0}\"',
    Dependency_Warning_Text: 'L\'opération n\'a pas pu être effectuée. ',
    Details: 'Détails',
    Edit_Text: 'Modifier',
    empty_sorting_list: 'Aucune option de tri trouvée',
    EnterProjectName: 'Saisir le nom du projet',
    EnterTaskName: 'Saisir le nom de la tâche',
    EnterViewName_Text: 'Saisir le nom de la vue',
    Error_DragAndDrop_BreakingHierarchy: 'Une activité ne peut pas être l\'enfant de sa propre sous-activité.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Veuillez passer à la vue hiérarchique pour modifier la hiérarchie des activités.',
    Error_DragAndDrop_CycleDependencies: 'Cette opération créera une dépendance cyclique (par exemple, la tâche A dépend de la tâche B, la tâche B dépend de la tâche A).',
    Error_DragAndDrop_DifferentProjects: 'Vous ne pouvez pas déplacer une activité vers un autre projet (utilisez les détails de l\'activité).',
    Error_DragAndDrop_ReorderWithSorting: 'Pour réorganiser les activités, un tri croissant du WBS doit être appliqué.',
    Error_PresetNotFound: 'La vue sélectionnée a été supprimée ou n\'est plus partagée. Pour continuer, actualisez la page.',
    EstimatedHours_problem: 'Les heures réelles dépassent les heures estimées',
    export_activities: 'Activités',
    export_activities_expanded_only: 'Activités (développées uniquement)',
    Export_Activities_Text: 'Exporter les activités en CSV',
    Export_Import_Text: 'Exporter & Importer',
    export_projects: 'Projets',
    Export_Projects_Text: 'Exporter les projets en CSV',
    flat_view: 'Vue plate',
    From: 'de',
    Group_By_Portfolio: 'Grouper par portefeuille',
    group_by_project: 'Grouper par projet',
    Hide_Counter: 'Masquer le compteur de Projets/Activités',
    Hide_Text: 'Masquer',
    hide_uncategorized_tasks: 'Masquer les activités ne correspondant à aucun calendrier',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Importer depuis CSV',
    Import_MSProject_Text: 'Importer depuis MS Project',
    Import_Text: 'Importer',
    Indicator_Counter_Snooze_Tooltip: '1#{0} élément a des problèmes#{0} éléments ont des problèmes',
    Indicator_Counter_Tooltip: 'Nombre d\'activités à risque',
    Indicator_Project_Tooltip: 'Le projet nécessite une attention à :',
    Indicator_Snooze_1_Week: 'Pendant 1 semaine',
    Indicator_Snooze_4_Hours: 'Pendant 4 heures',
    Indicator_Snooze_Cancel: 'Annuler le report',
    Indicator_Snooze_Custom: 'Personnalisé',
    Indicator_Snooze_Custom_Modal_Header: 'Report d\'indication',
    Indicator_Snooze_Forever: 'Pour toujours',
    Indicator_Snooze_Menu_Text: 'Reporter l\'indication de problème',
    Indicator_Snooze_Message: 'Indication de problème reportée pour vous jusqu\'à {0}.',
    Indicator_Snooze_Message_Forever: 'Indication de problème reportée pour vous indéfiniment.',
    Indicator_Snooze_Until_Tomorrow: 'Jusqu\'à demain',
    Indicator_Task_Tooltip: 'L\'activité nécessite une attention à :',
    Learn_More_Text: 'En savoir plus',
    Loading_Text: 'Chargement...',
    More_Tasks: '{0} de plus',
    MoreActions_AddAIActivities: 'Créer un plan de projet avec l\'IA',
    MoreActions_AddNextActivity: 'Ajouter l\'activité suivante',
    MoreActions_AddSubActivity: 'Ajouter une sous-activité',
    MoreActions_SaveProjectAsTemplate: 'Enregistrer comme modèle',
    MoreActions_SetAsMilestone: 'Définir comme jalon',
    MoreActions_UnsetAsMilestone: 'Annuler le jalon',
    My_Presets: 'Mes vues',
    My_Text: 'Moi',
    MyPresetName_Text: 'Le mien',
    NewProject: 'Nouveau projet',
    NewProjectBasedOn: 'Nouveau projet basé sur {0}',
    NewTask: 'Nouvelle tâche',
    no_custom_field_value_label: 'n/d',
    No_Portfolio: 'Sans portefeuille',
    no_project_custom_fields_created_text: 'Aucun champ personnalisé de projet créé',
    No_Templates_Text: 'Aucun modèle trouvé.',
    NoSavedViews_Text: 'Aucune vue enregistrée.',
    Of: 'sur',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Activités parentes',
    Portfolios_Text: '1#{0} Portefeuille#{0} Portefeuilles',
    preset_delete: 'Supprimer la vue',
    preset_delete_confirmation: 'Supprimer la vue enregistrée \"{0}\" ?',
    preset_rename: 'Renommer la vue',
    preset_save: 'Enregistrer la vue',
    preset_saveAs: 'Enregistrer la vue sous',
    preset_share: 'Partager avec tout le monde dans cet espace',
    preset_unshare_confirmation: 'Annuler le partage de la vue {0} ?',
    Project: 'Projet',
    Project_ActualBudgetProfitability: 'Rentabilité réelle du budget',
    Project_BudgetedCost: 'Budget total du projet',
    Project_CostVariance: 'Écart de coût',
    Project_EstimatedBudgetProfitability: 'Rentabilité budgétaire estimée',
    Project_Expenses: 'Dépenses',
    project_info: 'Infos du projet',
    Project_InternalCost: 'Coût réel',
    Project_ProjectBilling: 'Facturation du projet',
    Project_ProjectProfit: 'Profit du projet',
    Project_ProjectProfitability: 'Rentabilité',
    ProjectArchive: 'Projet (archivé)',
    ProjectEndDate_problem: 'Le projet n\'a pas été terminé à la date d\'échéance',
    Projects: '1#Projet#Projets',
    Projects_Text: '1#{0} Projet#{0} Projets',
    Rename_Text: 'Renommer',
    Restore_Text: 'Restaurer',
    Save_Text: 'Enregistrer',
    SaveAs_Text: 'Enregistrer sous',
    Share_Text: 'Partager',
    Shared_With_Me: 'Partagé avec moi',
    show_archived_projects: 'Afficher les projets archivés',
    Show_Text: 'Afficher',
    SortBy_Text: 'Trier par',
    SPI_Problem: 'L’IPS est en dessous du seuil',
    SubActivities: '1#Sous-activité#Sous-activités',
    switchToClassicUI: 'Basculer vers l’ancienne interface',
    switchToNewUI: 'Basculer vers la nouvelle interface',
    tab_Board: 'Tableau',
    tab_Calendar: 'Calendrier',
    tab_Gantt: 'Gantt',
    tab_Table: 'Tableau',
    TargetProfit_warning: 'Le bénéfice cible est inférieur au bénéfice attendu',
    TargetProfitPercentage_warning: 'Le pourcentage du bénéfice cible (%) est inférieur au pourcentage du bénéfice attendu (%)',
    TaskEndDate_problem: 'La tâche n’a pas été terminée à la date d’échéance',
    TaskEndDate_warning: 'La tâche se termine après sa tâche parente',
    TaskStartDate_warning: 'La tâche commence avant sa tâche parente',
    Templates_Popup_Title: 'Basé sur le modèle :',
    TimerText: '1#{0} seconde#{0} secondes',
    Tools_Menu_Text: 'Outils',
    Tooltip_DefaultPresetIcon: 'Sélectionner ou gérer les vues enregistrées',
    Tooltip_RevertToDefaultPreset: 'Revenir à la vue par défaut',
    Tooltip_SaveDefaultPreset: 'Enregistrez votre disposition et vos filtres actuels comme une vue',
    Tooltip_SharedByMePreset: 'Partagé par moi',
    TotalTargetRevenue_warning: 'La facturation EAC est inférieure au revenu cible total',
    Unarchive_Success_Message: 'Le projet « {0} » a été désarchivé.',
    uncategorized_tasks: 'Activités sans calendriers',
    Unshare_Text: 'Ne plus partager',
    View_Project_Link: 'Voir le projet',
    WBSNumber_Text: 'SBS',
    what_to_export: 'Qu’exporter ?',
};
